<div class="liens-page min-h-screen sm:py-12 py-6 h-full flex flex-col bg-gray-50 justify-center">
  <section class="my-auto">
    <div class="container max-w-xl mx-auto px-6">

      <!-- Tag APPLICATION MOBILE & WEB -->
      <div class="inline-flex w-fit items-center gap-2 border border-gray-300 rounded-full px-5 py-2 mb-6 bg-white/80">
        <svg class="w-4 h-4 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
            d="M12 18h.01M8 21h8a2 2 0 002-2V5a2 2 0 00-2-2H8a2 2 0 00-2 2v14a2 2 0 002 2z" />
        </svg>
        <span class="text-gray-700 text-xs font-medium uppercase tracking-wide">Application mobile</span>
      </div>

      <h1 class="text-[#343A40] max-sm:text-2xl! md:text-4xl lg:text-[2.5rem] font-bold uppercase md:normal-case mb-3">
        Votre Espace Santé, partout avec vous
      </h1>
      <p class="text-gray-600 text-sm! md:text-base! max-w-xl mb-10! leading-relaxed!">
        Téléchargez l’application pour accéder à vos informations de santé et celles de vos proches, à tout moment.
      </p>

      <!-- Télécharger l'application mobile -->
      <h2 class="text-gray-500 font-semibold max-sm:text-lg! mb-4">
        Télécharger l'application
      </h2>
      <div class="flex flex-col sm:flex-row gap-4">

        <!-- App Store -->
        <a [href]="appStoreUrl" target="_blank" rel="noopener noreferrer"
          class="liens-btn-appstore inline-flex items-center justify-center gap-3 px-6 py-4 rounded-lg font-medium transition-all duration-200 focus:outline-none">
          <svg class="w-7 h-7 flex-shrink-0" viewBox="0 0 24 24" fill="white" aria-hidden="true">
            <path
              d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.81-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z" />
          </svg>
          <span>
            <span class="block text-xs opacity-80 leading-none mb-0.5">Télécharger sur</span>
            <span class="block text-base font-semibold leading-none">App Store</span>
          </span>
        </a>

        <!-- Google Play -->
        <a [href]="playStoreUrl" target="_blank" rel="noopener noreferrer"
          class="liens-btn-playstore inline-flex items-center justify-center gap-3 px-6 py-4 rounded-lg font-medium transition-all duration-200 focus:outline-none">
          <svg class="w-7 h-7 flex-shrink-0" viewBox="0 0 24 24" aria-hidden="true">
            <path fill="#4285F4" d="M3.609 1.814L13.792 12 3.61 22.186a.996.996 0 01-.61-.92V2.734a1 1 0 01.609-.92z" />
            <path fill="#FBBC04" d="M16.802 8.99l-2.302 2.302-8.636-8.634L16.802 8.99z" />
            <path fill="#EA4335" d="M20.297 8.994l2.807 1.626a1 1 0 010 1.73l-2.808 1.626L17.794 12l2.503-2.006z" />
            <path fill="#34A853" d="M14.463 14.514l2.302 2.302-10.901 6.312 8.599-8.614z" />
          </svg>
          <span>
            <span class="block text-xs opacity-70 leading-none mb-0.5">Télécharger sur</span>
            <span class="block text-base font-semibold leading-none">Google Play</span>
          </span>
        </a>

      </div>
    </div>
  </section>
</div>